export default __webpack_public_path__ + "static/media/drone14.14c8ce3a.jpg";